import React from 'react';
import useStyles from './useStyle';
import { useIsMobile } from '~/hooks/useIsMobile';
import { COLORS } from '~/data/ui/colors';

type FrameProps = {
  text: string | React.ReactNode;
  color?: string;
  icon?: React.ReactNode;
  hideTriangleOnMobile?: boolean;
};

const Frame: React.FC<FrameProps> = ({
  text,
  color = `${COLORS.blue.light2}`,
  icon,
  hideTriangleOnMobile = false,
}) => {
  const isMobile = useIsMobile();

  const styles = useStyles({ color, hideTriangleOnMobile, isMobile });

  return (
    <div style={styles.container}>
      {icon && <span style={styles.icon}>{icon}</span>}
      <div style={styles.text}>{text}</div>
      <div style={styles.triangle}></div>
    </div>
  );
};

export default Frame;
